import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { useView } from "../ResourceViewPage";
import { Box, Button, Typography } from "@mui/material";
import { Container } from "reactstrap";
import RenderForm from "../../../Components/Esaedro/RenderForm/RenderForm";
import { ResourceNames } from "../../../Utils/ResourceNames";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import { useQuery } from "react-query";
import { Form } from "../../../Models/SysConf/Form";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { RoutePath } from "../../../Utils/RoutePath";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { CustomColumn } from "../../../Models/Project/CustomColumn";
import { DataGrid } from "devextreme-react";
import { Column, Editing, FilterRow } from "devextreme-react/data-grid";
import { ResourceViewSortField } from "../../../Models/SysConf/ResourceViewSortField";
import notify from "devextreme/ui/notify";
import { ResourceView } from "../../../Models/SysConf/ResourceView";
import { set } from "lodash";
import Loader from "../../../Utils/Loader";
import { Filter } from "@mui/icons-material";

type Props = {};

type ContextType = {
  objEdit: ResourceView;
  setObjEdit: React.Dispatch<React.SetStateAction<ResourceView>>;
};

export default function OrdinancesPage(props: Props) {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  // React Router DOM
  const { view, setView } = useView();
  const navigate = useNavigate();
  const location = useLocation();

  // hooks
  const columnsDataGridResourcesViewSortFields: CustomColumn[] = [
    {
      caption: "Risorsa",
      dataField: "ResourceName",
    },
    {
      caption: "Campo",
      dataField: "FieldName",
    },
    {
      caption: "Tipo",
      dataField: "SortType",
    },
  ];
  const [isNewFormVisible, setNewFormVisible] = React.useState<boolean>(false);
  const [isEditFormVisible, setEditFormVisible] =
    React.useState<boolean>(false);
  const [objEdit, setObjEdit] = React.useState<ResourceView | {}>({});
  const [initalView, setInitialView] = React.useState<ResourceView>({
    ...view,
  });

  React.useEffect(() => {
    if (
      location.pathname ===
      `${RoutePath.RESOURCES_VIEWS}/${view?.View_ID}/ordinances`
    ) {
      setEditFormVisible(false);
    }
  }, [location.pathname]);

  // ChiamatE API
  const {
    data: resourcesViewsSortFields,
    isLoading: isLoadingResourcesViewsSortFields,
    isError: isErrorResourcesViewsSortFields,
    refetch: refetchResourcesViewsSortFields,
    isRefetching: isRefetchingResourcesViewsSortFields,
  } = useQuery(
    ["resourcesViewsSortFields", view?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsSortFields}?RecordSelection=View_ID=${view?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const { data: form, isLoading: isLoadingForm } = useQuery(
    ["form", ResourceNames.ResourcesViewes, userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewes}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formResourcesViewsSortFields,
    isLoading: isLoadingFormResourcesViewsSortFields,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsSortFields,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsSortFields}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewSortField: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsSortFields) {
      let tmpForm: Form = formResourcesViewsSortFields;

      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsSortFields]);

  // Chiamata per eliminare un ordinamento
  const deleteResourceViewSortField = (e: ResourceViewSortField) => {
    const service = new cubeApiClient();

    service
      .deleteObject(
        e,
        `api/sys/${ResourceNames.ResourcesViewsSortFields}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsSortFields();
          notify("Ordinamento eliminato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsSortFields();
          notify("Errore nell'eliminazione dell'ordinamento", "error", 1000);
        }
      );
  };

  // Chiamata per salvare un nuovo ordinamento
  const saveNewResourceViewSortField = () => {
    const service = new cubeApiClient();

    service
      .updateObject(
        view,
        `api/sys/${ResourceNames.ResourcesViewsSortFields}`,
        tokenApi
      )
      .then(
        (data) => {
          setNewFormVisible(false);
          refetchResourcesViewsSortFields();
          notify("Ordinamento salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsSortFields();
          notify("Errore nel salvataggio dell'ordinamento", "error", 1000);
        }
      );
  };

  //make the function to save the resourceVIewsortField
  const saveResourceViewSortField = (e: ResourceViewSortField) => {
    const service = new cubeApiClient();

    service
      .updateObject(
        e,
        `api/sys/${ResourceNames.ResourcesViewsSortFields}`,
        tokenApi
      )
      .then(
        (data) => {
          setEditFormVisible(false);
          refetchResourcesViewsSortFields();
          notify("Ordinamento salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsSortFields();
          notify("Errore nel salvataggio dell'ordinamento", "error", 1000);
        }
      );
  };

  // ! Inizio del DOM
  return (
    <>
      <Typography
        variant="h6"
        color={"primary.main"}
        style={{ fontWeight: 600, textAlign: "center" }}
        className="pt-3"
      >
        ORDINAMENTI
      </Typography>
      {view === undefined ||
      view === null ||
      resourcesViewsSortFields === undefined ||
      resourcesViewsSortFields === null ? (
        <Loader />
      ) : (
        <Container maxWidth="lg" sx={{ mt: 5 }}>
          {/* Bottone aggiungi, visulizzo il form e devisualizzo la DataGrid */}
          {!isNewFormVisible && !isEditFormVisible && (
            <Box sx={{ width: "100%", mb: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={() => {
                  setNewFormVisible(true);
                  setView(initalView);
                }}
              >
                Aggiungi
              </Button>
            </Box>
          )}
          <Box sx={{ height: "100%", width: "100%" }}>
            {!isNewFormVisible ? (
              <>
                {!isEditFormVisible ? (
                  <DataGrid
                    dataSource={resourcesViewsSortFields || []}
                    showBorders={true}
                    showRowLines={true}
                    showColumnLines={true}
                    className="mb-3"
                    onRowRemoved={(e) => {
                      deleteResourceViewSortField(
                        e.data as ResourceViewSortField
                      );
                    }}
                    onEditingStart={(e) => {
                      setObjEdit(e.data);
                      setEditFormVisible(true);
                      navigate("edit");
                    }}
                  >
                    <FilterRow visible={true} />
                    {columnsDataGridResourcesViewSortFields.map(
                      (column: CustomColumn, i: number) => (
                        <Column
                          key={i}
                          dataField={column.dataField}
                          caption={column.caption}
                        />
                      )
                    )}
                    <Editing
                      mode="row"
                      allowUpdating={true}
                      allowDeleting={true}
                      confirmDelete={true}
                      useIcons={true}
                      startEditAction="click"
                    />
                  </DataGrid>
                ) : (
                  <Outlet context={{ objEdit, setObjEdit }} />
                )}
              </>
            ) : (
              <RenderFormNew
                showTitle={false}
                isNew={true}
                form={formResourceViewSortField}
                myObj={view}
                saveNewObject={(e) => {
                  setView(e);
                }}
              />
            )}

            {/* Box di bottoni di Annulla e Salva */}
            {isNewFormVisible ? (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  flexDirection: "row",
                }}
              >
                {/* Bottone di Anulla, mi riporta alla DataGrid */}
                <Button
                  variant="contained"
                  color="error"
                  className="me-2"
                  onClick={() => setNewFormVisible(false)}
                >
                  Annulla
                </Button>

                {/* Bottone salva */}
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => saveNewResourceViewSortField()}
                >
                  Salva
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  flexDirection: "row",
                }}
              >
                {/* Bottone di Anulla, mi riporta al form iniziale */}

                {!isEditFormVisible && !isNewFormVisible && (
                  <>
                    <NavLink
                      to={`${RoutePath.RESOURCES_VIEWS}/${view.View_ID}`}
                    >
                      <Button
                        variant="contained"
                        color="error"
                        className="me-2"
                        onClick={() => setNewFormVisible(false)}
                      >
                        Torna Indietro
                      </Button>
                    </NavLink>

                    {/* Bottone salva, mi riporta alla home*/}
                    <NavLink to={RoutePath.RESOURCES_VIEWS}>
                      <Button variant="contained" color="success">
                        Torna alla griglia
                      </Button>
                    </NavLink>
                  </>
                )}
              </Box>
            )}
          </Box>
        </Container>
      )}
    </>
  );
}

export function useOrdinancesObjEdit() {
  return useOutletContext<ContextType>();
}
